import { $t } from '../../composables/i18n'
import { Color } from '../color/Color'
import { Codebook } from '../Codebook'
import { PaymentOperationTypeId } from '../payment-operation-type-id/PaymentOperationTypeId'

export class PaymentOperationType extends Codebook<PaymentOperationTypeId> {
  static readonly INCOME = new PaymentOperationType(
    PaymentOperationTypeId.INCOME,
    () => $t('Income'),
    Color.POSITIVE,
  )
  static readonly EXPENSE = new PaymentOperationType(
    PaymentOperationTypeId.EXPENSE,
    () => $t('Expense'),
    Color.NEGATIVE,
  )

  private constructor(
    public readonly id: PaymentOperationTypeId,
    public readonly name: () => string,
    public readonly color: Color.POSITIVE | Color.NEGATIVE,
  ) {
    super(id)
  }
}
